import { Input } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";
import { If } from "@components/control-statements";
import styles from "@styles/pages/cdp/filters.module.scss";
import { useEffect, useState } from "react";

export default function VariableValueForm({
  data,
  input_configs = {},
  onChange,
}) {
  const formatValue = (operand, value) => {
    if (operand === "bt") return Array.isArray(value) ? value : [null, null];

    return value;
  };

  const [values, setValues] = useState(formatValue(data.operand, data.values));

  const is_number = ["currency", "number"].includes(input_configs?.type);
  const InputComponent = is_number ? CurrencyInput : Input;

  useEffect(() => {
    onChange({ ...data, values });
  }, [values]);

  return (
    <>
      <If cond={data.operand !== "bt"}>
        <InputComponent
          {...(input_configs || {})}
          value={formatValue(data.operand, values)}
          onChange={(e, m, v) => {
            const value = is_number ? v : e === null ? "" : e.target.value;
            setValues(value);
          }}
          autoFocus
          className="mb-0"
        />
      </If>
      <If cond={data.operand == "bt"}>
        <div className="d-flex align-center">
          <InputComponent
            {...(input_configs || {})}
            value={formatValue(data.operand, values)[0]}
            placeholder="De"
            autoFocus
            onChange={(e, m, _val) => {
              const v = formatValue(data.operand, values);
              const _value = is_number
                ? _val
                : e === null
                ? ""
                : e?.target?.value;
              setValues([_value, v[1]]);
            }}
            className="mb-0"
          />
          <span className={styles.to}>Até</span>
          <InputComponent
            {...(input_configs || {})}
            value={formatValue(data.operand, values)[1]}
            placeholder="Até"
            onChange={(e, m, _val) => {
              const v = formatValue(data.operand, values);
              const _value = is_number
                ? _val
                : e === null
                ? ""
                : e?.target?.value;
              setValues([v[0], _value]);
            }}
            className="mb-0"
          />
        </div>
      </If>
    </>
  );
}
